import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const ProfileButton = ({ className, children, ...rest }) => (
  <button
    className={classnames(
      'w-48 text-sm px-5 h-12 py-3 font-bold rounded-full text-black outline-none max-w-full md:h-14 md:py-3 bg-secondaryGradient focus:ring focus:ring-primary-600 focus:ring-opacity-50 hover:opacity-90 disabled:opacity-90 disabled:cursor-not-allowed',
      className
    )}
    {...rest}
  >
    {children}
  </button>
)

ProfileButton.defaultProps = {
  className: '',
}

ProfileButton.propTypes = {
  className: PropTypes.string,
}

export default ProfileButton
